import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  .ant-card-head-wrapper {
    align-items: center;
  }
`;
